__turbopack_context__.v({
  "acheivername": "faculty-list-module__XvgN6W__acheivername",
  "acheiverrank": "faculty-list-module__XvgN6W__acheiverrank",
  "active": "faculty-list-module__XvgN6W__active",
  "checkboxcontent": "faculty-list-module__XvgN6W__checkboxcontent",
  "facultyImage": "faculty-list-module__XvgN6W__facultyImage",
  "facultyborder1": "faculty-list-module__XvgN6W__facultyborder1",
  "facultyborder2": "faculty-list-module__XvgN6W__facultyborder2",
  "facultyborder3": "faculty-list-module__XvgN6W__facultyborder3",
  "facultyboxheight": "faculty-list-module__XvgN6W__facultyboxheight",
  "imagee": "faculty-list-module__XvgN6W__imagee",
  "img": "faculty-list-module__XvgN6W__img",
  "innerRing": "faculty-list-module__XvgN6W__innerRing",
  "modalheaderborder": "faculty-list-module__XvgN6W__modalheaderborder",
  "nav-item": "faculty-list-module__XvgN6W__nav-item",
  "nav-link": "faculty-list-module__XvgN6W__nav-link",
  "nav-pills": "faculty-list-module__XvgN6W__nav-pills",
  "nav-tabs": "faculty-list-module__XvgN6W__nav-tabs",
  "outerRing": "faculty-list-module__XvgN6W__outerRing",
  "pagemaintitle": "faculty-list-module__XvgN6W__pagemaintitle",
  "redunderline": "faculty-list-module__XvgN6W__redunderline",
  "redunderlinealink": "faculty-list-module__XvgN6W__redunderlinealink",
  "sectiontitle": "faculty-list-module__XvgN6W__sectiontitle",
  "show": "faculty-list-module__XvgN6W__show",
  "tabactive": "faculty-list-module__XvgN6W__tabactive",
  "tablinks": "faculty-list-module__XvgN6W__tablinks",
  "tabscrollclass": "faculty-list-module__XvgN6W__tabscrollclass",
  "tabsection": "faculty-list-module__XvgN6W__tabsection",
});
